/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as MarketingRouteImport } from './routes/_marketing'
import { Route as OnboardingRouteImport } from './routes/_onboarding'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AppAtChar123usernameChar125RouteImport } from './routes/_app/@{$username}'
import { Route as AppAuthedRouteImport } from './routes/_app/_authed'
import { Route as AppCommunitiesRouteImport } from './routes/_app/communities'
import { Route as AppExploreRouteImport } from './routes/_app/explore'
import { Route as AppFeedRouteImport } from './routes/_app/feed'
import { Route as AppJobsRouteImport } from './routes/_app/jobs'
import { Route as AppMarketplaceRouteImport } from './routes/_app/marketplace'
import { Route as AppMessagesRouteImport } from './routes/_app/messages'
import { Route as AppNotificationsRouteImport } from './routes/_app/notifications'
import { Route as MarketingIndexRouteImport } from './routes/_marketing/index'
import { Route as OnboardingJoinRouteImport } from './routes/_onboarding/join'
import { Route as OnboardingOnboardingRouteImport } from './routes/_onboarding/onboarding'
import { Route as OnboardingWelcomeRouteImport } from './routes/_onboarding/welcome'
import { Route as DashboardIndexRouteImport } from './routes/dashboard.index'
import { Route as DashboardAnalyticsRouteImport } from './routes/dashboard.analytics'
import { Route as DashboardCustomersRouteImport } from './routes/dashboard.customers'
import { Route as DashboardOrdersRouteImport } from './routes/dashboard.orders'
import { Route as DashboardProductsRouteImport } from './routes/dashboard.products'
import { Route as DashboardSettingsRouteImport } from './routes/dashboard.settings'
import { Route as DevUiRouteImport } from './routes/dev.ui'
import { Route as AppCSlugRouteImport } from './routes/_app/c.$slug'
import { Route as AppMarketplaceGametypesRouteImport } from './routes/_app/marketplace_.gametypes'
import { Route as AppMarketplaceStoresRouteImport } from './routes/_app/marketplace_.stores'
import { Route as AppPSlugRouteImport } from './routes/_app/p.$slug'
import { Route as AppStoreSlugRouteImport } from './routes/_app/store.$slug'
import { Route as OnboardingJoinIndexRouteImport } from './routes/_onboarding/join.index'
import { Route as OnboardingJoinEmailRouteImport } from './routes/_onboarding/join.email'
import { Route as OnboardingOnboardingIndexRouteImport } from './routes/_onboarding/onboarding.index'
import { Route as OnboardingOnboardingStoreRouteImport } from './routes/_onboarding/onboarding.store'
import { Route as DashboardProductsProductIdRouteImport } from './routes/dashboard.products_.$productId'
import { Route as AppAuthedSellIndexRouteImport } from './routes/_app/_authed/sell.index'
import { Route as AppAuthedSellNewRouteImport } from './routes/_app/_authed/sell.new'
import { Route as AppAuthedSettingsAccountRouteImport } from './routes/_app/_authed/settings.account'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketingRoute = MarketingRouteImport.update({
  id: '/_marketing',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/_onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAtChar123usernameChar125Route =
  AppAtChar123usernameChar125RouteImport.update({
    id: '/@{$username}',
    path: '/@{$username}',
    getParentRoute: () => AppRoute,
  } as any)
const AppAuthedRoute = AppAuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => AppRoute,
} as any)
const AppCommunitiesRoute = AppCommunitiesRouteImport.update({
  id: '/communities',
  path: '/communities',
  getParentRoute: () => AppRoute,
} as any)
const AppExploreRoute = AppExploreRouteImport.update({
  id: '/explore',
  path: '/explore',
  getParentRoute: () => AppRoute,
} as any)
const AppFeedRoute = AppFeedRouteImport.update({
  id: '/feed',
  path: '/feed',
  getParentRoute: () => AppRoute,
} as any)
const AppJobsRoute = AppJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AppRoute,
} as any)
const AppMarketplaceRoute = AppMarketplaceRouteImport.update({
  id: '/marketplace',
  path: '/marketplace',
  getParentRoute: () => AppRoute,
} as any)
const AppMessagesRoute = AppMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const MarketingIndexRoute = MarketingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MarketingRoute,
} as any)
const OnboardingJoinRoute = OnboardingJoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingOnboardingRoute = OnboardingOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingWelcomeRoute = OnboardingWelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => OnboardingRoute,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAnalyticsRoute = DashboardAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCustomersRoute = DashboardCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardOrdersRoute = DashboardOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardProductsRoute = DashboardProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRoute,
} as any)
const DevUiRoute = DevUiRouteImport.update({
  id: '/dev/ui',
  path: '/dev/ui',
  getParentRoute: () => rootRouteImport,
} as any)
const AppCSlugRoute = AppCSlugRouteImport.update({
  id: '/c/$slug',
  path: '/c/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppMarketplaceGametypesRoute = AppMarketplaceGametypesRouteImport.update({
  id: '/marketplace_/gametypes',
  path: '/marketplace/gametypes',
  getParentRoute: () => AppRoute,
} as any)
const AppMarketplaceStoresRoute = AppMarketplaceStoresRouteImport.update({
  id: '/marketplace_/stores',
  path: '/marketplace/stores',
  getParentRoute: () => AppRoute,
} as any)
const AppPSlugRoute = AppPSlugRouteImport.update({
  id: '/p/$slug',
  path: '/p/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppStoreSlugRoute = AppStoreSlugRouteImport.update({
  id: '/store/$slug',
  path: '/store/$slug',
  getParentRoute: () => AppRoute,
} as any)
const OnboardingJoinIndexRoute = OnboardingJoinIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OnboardingJoinRoute,
} as any)
const OnboardingJoinEmailRoute = OnboardingJoinEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => OnboardingJoinRoute,
} as any)
const OnboardingOnboardingIndexRoute =
  OnboardingOnboardingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OnboardingOnboardingRoute,
  } as any)
const OnboardingOnboardingStoreRoute =
  OnboardingOnboardingStoreRouteImport.update({
    id: '/store',
    path: '/store',
    getParentRoute: () => OnboardingOnboardingRoute,
  } as any)
const DashboardProductsProductIdRoute =
  DashboardProductsProductIdRouteImport.update({
    id: '/products_/$productId',
    path: '/products/$productId',
    getParentRoute: () => DashboardRoute,
  } as any)
const AppAuthedSellIndexRoute = AppAuthedSellIndexRouteImport.update({
  id: '/sell/',
  path: '/sell/',
  getParentRoute: () => AppAuthedRoute,
} as any)
const AppAuthedSellNewRoute = AppAuthedSellNewRouteImport.update({
  id: '/sell/new',
  path: '/sell/new',
  getParentRoute: () => AppAuthedRoute,
} as any)
const AppAuthedSettingsAccountRoute =
  AppAuthedSettingsAccountRouteImport.update({
    id: '/settings/account',
    path: '/settings/account',
    getParentRoute: () => AppAuthedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof MarketingIndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/@{$username}': typeof AppAtChar123usernameChar125Route
  '/communities': typeof AppCommunitiesRoute
  '/explore': typeof AppExploreRoute
  '/feed': typeof AppFeedRoute
  '/jobs': typeof AppJobsRoute
  '/marketplace': typeof AppMarketplaceRoute
  '/messages': typeof AppMessagesRoute
  '/notifications': typeof AppNotificationsRoute
  '/join': typeof OnboardingJoinRouteWithChildren
  '/onboarding': typeof OnboardingOnboardingRouteWithChildren
  '/welcome': typeof OnboardingWelcomeRoute
  '/dashboard/analytics': typeof DashboardAnalyticsRoute
  '/dashboard/customers': typeof DashboardCustomersRoute
  '/dashboard/orders': typeof DashboardOrdersRoute
  '/dashboard/products': typeof DashboardProductsRoute
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/dev/ui': typeof DevUiRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/c/$slug': typeof AppCSlugRoute
  '/marketplace/gametypes': typeof AppMarketplaceGametypesRoute
  '/marketplace/stores': typeof AppMarketplaceStoresRoute
  '/p/$slug': typeof AppPSlugRoute
  '/store/$slug': typeof AppStoreSlugRoute
  '/join/email': typeof OnboardingJoinEmailRoute
  '/onboarding/store': typeof OnboardingOnboardingStoreRoute
  '/dashboard/products/$productId': typeof DashboardProductsProductIdRoute
  '/join/': typeof OnboardingJoinIndexRoute
  '/onboarding/': typeof OnboardingOnboardingIndexRoute
  '/sell/new': typeof AppAuthedSellNewRoute
  '/settings/account': typeof AppAuthedSettingsAccountRoute
  '/sell/': typeof AppAuthedSellIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof MarketingIndexRoute
  '/@{$username}': typeof AppAtChar123usernameChar125Route
  '/communities': typeof AppCommunitiesRoute
  '/explore': typeof AppExploreRoute
  '/feed': typeof AppFeedRoute
  '/jobs': typeof AppJobsRoute
  '/marketplace': typeof AppMarketplaceRoute
  '/messages': typeof AppMessagesRoute
  '/notifications': typeof AppNotificationsRoute
  '/welcome': typeof OnboardingWelcomeRoute
  '/dashboard/analytics': typeof DashboardAnalyticsRoute
  '/dashboard/customers': typeof DashboardCustomersRoute
  '/dashboard/orders': typeof DashboardOrdersRoute
  '/dashboard/products': typeof DashboardProductsRoute
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/dev/ui': typeof DevUiRoute
  '/dashboard': typeof DashboardIndexRoute
  '/c/$slug': typeof AppCSlugRoute
  '/marketplace/gametypes': typeof AppMarketplaceGametypesRoute
  '/marketplace/stores': typeof AppMarketplaceStoresRoute
  '/p/$slug': typeof AppPSlugRoute
  '/store/$slug': typeof AppStoreSlugRoute
  '/join/email': typeof OnboardingJoinEmailRoute
  '/onboarding/store': typeof OnboardingOnboardingStoreRoute
  '/dashboard/products/$productId': typeof DashboardProductsProductIdRoute
  '/join': typeof OnboardingJoinIndexRoute
  '/onboarding': typeof OnboardingOnboardingIndexRoute
  '/sell/new': typeof AppAuthedSellNewRoute
  '/settings/account': typeof AppAuthedSettingsAccountRoute
  '/sell': typeof AppAuthedSellIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_marketing': typeof MarketingRouteWithChildren
  '/_onboarding': typeof OnboardingRouteWithChildren
  '/dashboard': typeof DashboardRouteWithChildren
  '/_app/@{$username}': typeof AppAtChar123usernameChar125Route
  '/_app/_authed': typeof AppAuthedRouteWithChildren
  '/_app/communities': typeof AppCommunitiesRoute
  '/_app/explore': typeof AppExploreRoute
  '/_app/feed': typeof AppFeedRoute
  '/_app/jobs': typeof AppJobsRoute
  '/_app/marketplace': typeof AppMarketplaceRoute
  '/_app/messages': typeof AppMessagesRoute
  '/_app/notifications': typeof AppNotificationsRoute
  '/_onboarding/join': typeof OnboardingJoinRouteWithChildren
  '/_onboarding/onboarding': typeof OnboardingOnboardingRouteWithChildren
  '/_onboarding/welcome': typeof OnboardingWelcomeRoute
  '/dashboard/analytics': typeof DashboardAnalyticsRoute
  '/dashboard/customers': typeof DashboardCustomersRoute
  '/dashboard/orders': typeof DashboardOrdersRoute
  '/dashboard/products': typeof DashboardProductsRoute
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/dev/ui': typeof DevUiRoute
  '/_marketing/': typeof MarketingIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/_app/c/$slug': typeof AppCSlugRoute
  '/_app/marketplace_/gametypes': typeof AppMarketplaceGametypesRoute
  '/_app/marketplace_/stores': typeof AppMarketplaceStoresRoute
  '/_app/p/$slug': typeof AppPSlugRoute
  '/_app/store/$slug': typeof AppStoreSlugRoute
  '/_onboarding/join/email': typeof OnboardingJoinEmailRoute
  '/_onboarding/onboarding/store': typeof OnboardingOnboardingStoreRoute
  '/dashboard/products_/$productId': typeof DashboardProductsProductIdRoute
  '/_onboarding/join/': typeof OnboardingJoinIndexRoute
  '/_onboarding/onboarding/': typeof OnboardingOnboardingIndexRoute
  '/_app/_authed/sell/new': typeof AppAuthedSellNewRoute
  '/_app/_authed/settings/account': typeof AppAuthedSettingsAccountRoute
  '/_app/_authed/sell/': typeof AppAuthedSellIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/@{$username}'
    | '/communities'
    | '/explore'
    | '/feed'
    | '/jobs'
    | '/marketplace'
    | '/messages'
    | '/notifications'
    | '/join'
    | '/onboarding'
    | '/welcome'
    | '/dashboard/analytics'
    | '/dashboard/customers'
    | '/dashboard/orders'
    | '/dashboard/products'
    | '/dashboard/settings'
    | '/dev/ui'
    | '/dashboard/'
    | '/c/$slug'
    | '/marketplace/gametypes'
    | '/marketplace/stores'
    | '/p/$slug'
    | '/store/$slug'
    | '/join/email'
    | '/onboarding/store'
    | '/dashboard/products/$productId'
    | '/join/'
    | '/onboarding/'
    | '/sell/new'
    | '/settings/account'
    | '/sell/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/@{$username}'
    | '/communities'
    | '/explore'
    | '/feed'
    | '/jobs'
    | '/marketplace'
    | '/messages'
    | '/notifications'
    | '/welcome'
    | '/dashboard/analytics'
    | '/dashboard/customers'
    | '/dashboard/orders'
    | '/dashboard/products'
    | '/dashboard/settings'
    | '/dev/ui'
    | '/dashboard'
    | '/c/$slug'
    | '/marketplace/gametypes'
    | '/marketplace/stores'
    | '/p/$slug'
    | '/store/$slug'
    | '/join/email'
    | '/onboarding/store'
    | '/dashboard/products/$productId'
    | '/join'
    | '/onboarding'
    | '/sell/new'
    | '/settings/account'
    | '/sell'
  id:
    | '__root__'
    | '/_app'
    | '/_marketing'
    | '/_onboarding'
    | '/dashboard'
    | '/_app/@{$username}'
    | '/_app/_authed'
    | '/_app/communities'
    | '/_app/explore'
    | '/_app/feed'
    | '/_app/jobs'
    | '/_app/marketplace'
    | '/_app/messages'
    | '/_app/notifications'
    | '/_onboarding/join'
    | '/_onboarding/onboarding'
    | '/_onboarding/welcome'
    | '/dashboard/analytics'
    | '/dashboard/customers'
    | '/dashboard/orders'
    | '/dashboard/products'
    | '/dashboard/settings'
    | '/dev/ui'
    | '/_marketing/'
    | '/dashboard/'
    | '/_app/c/$slug'
    | '/_app/marketplace_/gametypes'
    | '/_app/marketplace_/stores'
    | '/_app/p/$slug'
    | '/_app/store/$slug'
    | '/_onboarding/join/email'
    | '/_onboarding/onboarding/store'
    | '/dashboard/products_/$productId'
    | '/_onboarding/join/'
    | '/_onboarding/onboarding/'
    | '/_app/_authed/sell/new'
    | '/_app/_authed/settings/account'
    | '/_app/_authed/sell/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  MarketingRoute: typeof MarketingRouteWithChildren
  OnboardingRoute: typeof OnboardingRouteWithChildren
  DashboardRoute: typeof DashboardRouteWithChildren
  DevUiRoute: typeof DevUiRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_marketing': {
      id: '/_marketing'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MarketingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_onboarding': {
      id: '/_onboarding'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/@{$username}': {
      id: '/_app/@{$username}'
      path: '/@{$username}'
      fullPath: '/@{$username}'
      preLoaderRoute: typeof AppAtChar123usernameChar125RouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_authed': {
      id: '/_app/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppAuthedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/communities': {
      id: '/_app/communities'
      path: '/communities'
      fullPath: '/communities'
      preLoaderRoute: typeof AppCommunitiesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/explore': {
      id: '/_app/explore'
      path: '/explore'
      fullPath: '/explore'
      preLoaderRoute: typeof AppExploreRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/feed': {
      id: '/_app/feed'
      path: '/feed'
      fullPath: '/feed'
      preLoaderRoute: typeof AppFeedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/jobs': {
      id: '/_app/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof AppJobsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketplace': {
      id: '/_app/marketplace'
      path: '/marketplace'
      fullPath: '/marketplace'
      preLoaderRoute: typeof AppMarketplaceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/messages': {
      id: '/_app/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AppMessagesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_marketing/': {
      id: '/_marketing/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MarketingIndexRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_onboarding/join': {
      id: '/_onboarding/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof OnboardingJoinRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/_onboarding/onboarding': {
      id: '/_onboarding/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingOnboardingRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/_onboarding/welcome': {
      id: '/_onboarding/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof OnboardingWelcomeRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/analytics': {
      id: '/dashboard/analytics'
      path: '/analytics'
      fullPath: '/dashboard/analytics'
      preLoaderRoute: typeof DashboardAnalyticsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/customers': {
      id: '/dashboard/customers'
      path: '/customers'
      fullPath: '/dashboard/customers'
      preLoaderRoute: typeof DashboardCustomersRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/orders': {
      id: '/dashboard/orders'
      path: '/orders'
      fullPath: '/dashboard/orders'
      preLoaderRoute: typeof DashboardOrdersRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/products': {
      id: '/dashboard/products'
      path: '/products'
      fullPath: '/dashboard/products'
      preLoaderRoute: typeof DashboardProductsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/settings': {
      id: '/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof DashboardSettingsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dev/ui': {
      id: '/dev/ui'
      path: '/dev/ui'
      fullPath: '/dev/ui'
      preLoaderRoute: typeof DevUiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/c/$slug': {
      id: '/_app/c/$slug'
      path: '/c/$slug'
      fullPath: '/c/$slug'
      preLoaderRoute: typeof AppCSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketplace_/gametypes': {
      id: '/_app/marketplace_/gametypes'
      path: '/marketplace/gametypes'
      fullPath: '/marketplace/gametypes'
      preLoaderRoute: typeof AppMarketplaceGametypesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketplace_/stores': {
      id: '/_app/marketplace_/stores'
      path: '/marketplace/stores'
      fullPath: '/marketplace/stores'
      preLoaderRoute: typeof AppMarketplaceStoresRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/p/$slug': {
      id: '/_app/p/$slug'
      path: '/p/$slug'
      fullPath: '/p/$slug'
      preLoaderRoute: typeof AppPSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/store/$slug': {
      id: '/_app/store/$slug'
      path: '/store/$slug'
      fullPath: '/store/$slug'
      preLoaderRoute: typeof AppStoreSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_onboarding/join/': {
      id: '/_onboarding/join/'
      path: '/'
      fullPath: '/join/'
      preLoaderRoute: typeof OnboardingJoinIndexRouteImport
      parentRoute: typeof OnboardingJoinRoute
    }
    '/_onboarding/join/email': {
      id: '/_onboarding/join/email'
      path: '/email'
      fullPath: '/join/email'
      preLoaderRoute: typeof OnboardingJoinEmailRouteImport
      parentRoute: typeof OnboardingJoinRoute
    }
    '/_onboarding/onboarding/': {
      id: '/_onboarding/onboarding/'
      path: '/'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingOnboardingIndexRouteImport
      parentRoute: typeof OnboardingOnboardingRoute
    }
    '/_onboarding/onboarding/store': {
      id: '/_onboarding/onboarding/store'
      path: '/store'
      fullPath: '/onboarding/store'
      preLoaderRoute: typeof OnboardingOnboardingStoreRouteImport
      parentRoute: typeof OnboardingOnboardingRoute
    }
    '/dashboard/products_/$productId': {
      id: '/dashboard/products_/$productId'
      path: '/products/$productId'
      fullPath: '/dashboard/products/$productId'
      preLoaderRoute: typeof DashboardProductsProductIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_app/_authed/sell/': {
      id: '/_app/_authed/sell/'
      path: '/sell'
      fullPath: '/sell/'
      preLoaderRoute: typeof AppAuthedSellIndexRouteImport
      parentRoute: typeof AppAuthedRoute
    }
    '/_app/_authed/sell/new': {
      id: '/_app/_authed/sell/new'
      path: '/sell/new'
      fullPath: '/sell/new'
      preLoaderRoute: typeof AppAuthedSellNewRouteImport
      parentRoute: typeof AppAuthedRoute
    }
    '/_app/_authed/settings/account': {
      id: '/_app/_authed/settings/account'
      path: '/settings/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AppAuthedSettingsAccountRouteImport
      parentRoute: typeof AppAuthedRoute
    }
  }
}

interface AppAuthedRouteChildren {
  AppAuthedSellNewRoute: typeof AppAuthedSellNewRoute
  AppAuthedSettingsAccountRoute: typeof AppAuthedSettingsAccountRoute
  AppAuthedSellIndexRoute: typeof AppAuthedSellIndexRoute
}

const AppAuthedRouteChildren: AppAuthedRouteChildren = {
  AppAuthedSellNewRoute: AppAuthedSellNewRoute,
  AppAuthedSettingsAccountRoute: AppAuthedSettingsAccountRoute,
  AppAuthedSellIndexRoute: AppAuthedSellIndexRoute,
}

const AppAuthedRouteWithChildren = AppAuthedRoute._addFileChildren(
  AppAuthedRouteChildren,
)

interface AppRouteChildren {
  AppAtChar123usernameChar125Route: typeof AppAtChar123usernameChar125Route
  AppAuthedRoute: typeof AppAuthedRouteWithChildren
  AppCommunitiesRoute: typeof AppCommunitiesRoute
  AppExploreRoute: typeof AppExploreRoute
  AppFeedRoute: typeof AppFeedRoute
  AppJobsRoute: typeof AppJobsRoute
  AppMarketplaceRoute: typeof AppMarketplaceRoute
  AppMessagesRoute: typeof AppMessagesRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppCSlugRoute: typeof AppCSlugRoute
  AppMarketplaceGametypesRoute: typeof AppMarketplaceGametypesRoute
  AppMarketplaceStoresRoute: typeof AppMarketplaceStoresRoute
  AppPSlugRoute: typeof AppPSlugRoute
  AppStoreSlugRoute: typeof AppStoreSlugRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAtChar123usernameChar125Route: AppAtChar123usernameChar125Route,
  AppAuthedRoute: AppAuthedRouteWithChildren,
  AppCommunitiesRoute: AppCommunitiesRoute,
  AppExploreRoute: AppExploreRoute,
  AppFeedRoute: AppFeedRoute,
  AppJobsRoute: AppJobsRoute,
  AppMarketplaceRoute: AppMarketplaceRoute,
  AppMessagesRoute: AppMessagesRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppCSlugRoute: AppCSlugRoute,
  AppMarketplaceGametypesRoute: AppMarketplaceGametypesRoute,
  AppMarketplaceStoresRoute: AppMarketplaceStoresRoute,
  AppPSlugRoute: AppPSlugRoute,
  AppStoreSlugRoute: AppStoreSlugRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface MarketingRouteChildren {
  MarketingIndexRoute: typeof MarketingIndexRoute
}

const MarketingRouteChildren: MarketingRouteChildren = {
  MarketingIndexRoute: MarketingIndexRoute,
}

const MarketingRouteWithChildren = MarketingRoute._addFileChildren(
  MarketingRouteChildren,
)

interface OnboardingJoinRouteChildren {
  OnboardingJoinEmailRoute: typeof OnboardingJoinEmailRoute
  OnboardingJoinIndexRoute: typeof OnboardingJoinIndexRoute
}

const OnboardingJoinRouteChildren: OnboardingJoinRouteChildren = {
  OnboardingJoinEmailRoute: OnboardingJoinEmailRoute,
  OnboardingJoinIndexRoute: OnboardingJoinIndexRoute,
}

const OnboardingJoinRouteWithChildren = OnboardingJoinRoute._addFileChildren(
  OnboardingJoinRouteChildren,
)

interface OnboardingOnboardingRouteChildren {
  OnboardingOnboardingStoreRoute: typeof OnboardingOnboardingStoreRoute
  OnboardingOnboardingIndexRoute: typeof OnboardingOnboardingIndexRoute
}

const OnboardingOnboardingRouteChildren: OnboardingOnboardingRouteChildren = {
  OnboardingOnboardingStoreRoute: OnboardingOnboardingStoreRoute,
  OnboardingOnboardingIndexRoute: OnboardingOnboardingIndexRoute,
}

const OnboardingOnboardingRouteWithChildren =
  OnboardingOnboardingRoute._addFileChildren(OnboardingOnboardingRouteChildren)

interface OnboardingRouteChildren {
  OnboardingJoinRoute: typeof OnboardingJoinRouteWithChildren
  OnboardingOnboardingRoute: typeof OnboardingOnboardingRouteWithChildren
  OnboardingWelcomeRoute: typeof OnboardingWelcomeRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingJoinRoute: OnboardingJoinRouteWithChildren,
  OnboardingOnboardingRoute: OnboardingOnboardingRouteWithChildren,
  OnboardingWelcomeRoute: OnboardingWelcomeRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

interface DashboardRouteChildren {
  DashboardAnalyticsRoute: typeof DashboardAnalyticsRoute
  DashboardCustomersRoute: typeof DashboardCustomersRoute
  DashboardOrdersRoute: typeof DashboardOrdersRoute
  DashboardProductsRoute: typeof DashboardProductsRoute
  DashboardSettingsRoute: typeof DashboardSettingsRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardProductsProductIdRoute: typeof DashboardProductsProductIdRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardAnalyticsRoute: DashboardAnalyticsRoute,
  DashboardCustomersRoute: DashboardCustomersRoute,
  DashboardOrdersRoute: DashboardOrdersRoute,
  DashboardProductsRoute: DashboardProductsRoute,
  DashboardSettingsRoute: DashboardSettingsRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardProductsProductIdRoute: DashboardProductsProductIdRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  MarketingRoute: MarketingRouteWithChildren,
  OnboardingRoute: OnboardingRouteWithChildren,
  DashboardRoute: DashboardRouteWithChildren,
  DevUiRoute: DevUiRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
